(() => {
      const text = new Map([
        ['Customer Reviews', 'Klientų atsiliepimai'],
        ['Be the first to write a review', 'Parašykite pirmąjį atsiliepimą'],
        ['Write a review', 'Rašyti atsiliepimą'],
        ['How would you rate this product?', 'Kaip įvertintumėte šį produktą?'],
        ['We would love it if you would share a bit about your experience.', 'Pasidalykite savo patirtimi.'],
        ['Review content (Required)', 'Atsiliepimas (privalomas)'],
        ["We'll only contact you about your review if necessary. By submitting your review, you agree to our terms and conditions and privacy policy.", 'Dėl atsiliepimo su jumis susisieksime tik prireikus. Pateikdami atsiliepimą sutinkate su pirkimo sąlygomis ir privatumo politika.'],
        ['About you', 'Apie jus'],
        ['Please tell us more about you.', 'Trumpai papasakokite apie save.'],
        ['Email address (Required)', 'El. pašto adresas (privalomas)'],
        ['We respect your privacy.', 'Gerbiame jūsų privatumą.'],
        ['Display name (Required)', 'Rodomas vardas (privalomas)'],
        ["This won't be visible to other customers.", 'Tai nebus matoma kitiems klientams.'],
        ['Post review as anonymous', 'Skelbti atsiliepimą anonimiškai'],
        ['Share a picture', 'Pridėti nuotrauką'],
        ['Upload a photo to support your review.', 'Pridėkite nuotrauką prie atsiliepimo.'],
        ['Click to upload or drag and drop', 'Spustelėkite arba įkelkite failą nuvilkdami'],
        ['Back', 'Atgal'],
        ['Next', 'Toliau'],
        ['Submit', 'Pateikti'],
        ['Submit review', 'Pateikti atsiliepimą'],
        ['Thanks for your review!', 'Ačiū už atsiliepimą!'],
        ['We are processing it and it will appear on the store soon.', 'Atsiliepimą apdorojame, netrukus jis bus matomas parduotuvėje.'],
        ['Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.', 'Patvirtinkite el. pašto adresą spustelėdami ką tik išsiųstą nuorodą. Taip padedate užtikrinti atsiliepimų autentiškumą.'],
        ['Would you like to share your experience of shopping with us?', 'Ar norėtumėte pasidalyti apsipirkimo patirtimi?'],
        ['We value your feedback and use it to improve. Please share any thoughts or suggestions you have.', 'Vertiname jūsų nuomonę ir naudojame ją tobulėdami. Pasidalykite mintimis arba pasiūlymais.'],
        ['Close', 'Uždaryti'],
      ]);
      const placeholders = new Map([
        ['Start writing here...', 'Rašykite atsiliepimą čia...'],
        ['Your email address', 'Jūsų el. pašto adresas'],
        ['Display name', 'Rodomas vardas'],
      ]);
      const labels = new Map([
        ['Close review form', 'Uždaryti atsiliepimo formą'],
        ['Review form pages', 'Atsiliepimo formos puslapiai'],
        ['Rating', 'Įvertinimas'],
        ['Privacy and Terms', 'Privatumas ir sąlygos'],
        ['Review form navigation', 'Atsiliepimo formos navigacija'],
        ['Previous step', 'Ankstesnis žingsnis'],
        ['Next step', 'Kitas žingsnis'],
        ['Share a picture', 'Pridėti nuotrauką'],
      ]);
      const translate = (root) => {
        if (!(root instanceof Element) && root !== document.body) return;
        const selector = '.jdgm-widget, .jdgm-write-review-modal, .jdgm-rev-widg';
        const scopes = root === document.body ? [...document.querySelectorAll(selector)] : [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
        for (const scope of scopes) {
          const nodes = [];
          for (const element of [scope, ...scope.querySelectorAll('*')]) {
            for (const node of element.childNodes) if (node.nodeType === 3) nodes.push(node);
          }
          for (const node of nodes) {
            const value = node.nodeValue.replace(/\s+/g, ' ').trim();
            const replacement = text.get(value);
            if (!replacement) continue;
            const leading = node.nodeValue.match(/^\s*/)?.[0] || '';
            const trailing = node.nodeValue.match(/\s*$/)?.[0] || '';
            node.nodeValue = leading + replacement + trailing;
          }
          for (const element of scope.querySelectorAll('[placeholder]')) {
            const replacement = placeholders.get(element.getAttribute('placeholder'));
            if (replacement) element.setAttribute('placeholder', replacement);
          }
          for (const element of scope.querySelectorAll('[aria-label]')) {
            const value = element.getAttribute('aria-label');
            const star = value.match(/^(\d+) stars?$/);
            element.setAttribute('aria-label', star ? star[1] + ' žvaigždutės' : labels.get(value) || value);
            if (star && element.hasAttribute('title')) element.setAttribute('title', star[1] + ' žvaigždutės');
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__gdpr-statement')) {
            if (!element.textContent.includes("We'll only contact you")) continue;
            element.innerHTML = 'Dėl atsiliepimo su jumis susisieksime tik prireikus. Pateikdami atsiliepimą sutinkate su <a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">pirkimo sąlygomis</a> ir <a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">privatumo politika</a>.';
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__media-upload-prompt')) {
            if (!element.textContent.includes('Click to upload')) continue;
            element.innerHTML = '<b>Spustelėkite, kad įkeltumėte</b>, arba nuvilkite failą čia';
          }
        }
      };
      const run = () => translate(document.body);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
      else run();
      new MutationObserver(() => run()).observe(document.documentElement, { childList: true, subtree: true });
})();
